export type TemplateNamespaceState = {
  value: string,
}

export enum Actions {
  Example = 'template/Example'
}

export interface ExampleAction {
  type: Actions.Example
  payload: string,
}

export type TemplateAction =
  | ExampleAction
